import { on } from "events";


export const AppColors = {

  // 기본색상
  // Base Colors
  primary: "#FF5C00",
  secondary: "#97601A",
  tertiary: "#887E67",
  background: "#ffffff",
  surface: "#FFFFFF",

  // 텍스트 또는 any on 기본색상
  // Text or any content on base colors
  onPrimary: "#d82323",
  onSecondary: "#FFFFFF",
  onTertiary: "#000000",
  onBackground: "#000000",
  onSurface: "#000000",

  // 상태
  // Status Colors
  disabled: "#AEa9A6",
  error: "#f75226",
  success: "#25c800",
  warning: "#e79E00",
  info: "#2994E5",

  // 버튼
  // Button Colors
  buttonPrimary: "#45423B",
  buttonPrimaryHover: "#605641",
  buttonPrimaryActive: "#221D12",
  buttonSecondary: "#9C27B0",
  buttonSecondaryHover: "#8E24AA",
  buttonSecondaryActive: "#6A1B9A",
  buttonDisabled: "#E0E0E0",

  // 테그
  // Tag Colors
  tagPrimary: "#1976D2",
  tagSuccess: "#4CAF50",
  tagWarning: "#FFC107",
  tagError: "#B00020",
  tagInfo: "#2196F3",
  tagActive: "#FF5722",
  tagDisabled: "#9E9E9E",

  // 네비게이션
  // Navigation
  navigationBackground: "#1976D2",
  navigationText: "#FFFFFF",

  // 아이콘
  // Icon Colors
  iconPrimary: "#1976D2",
  iconSecondary: "#9C27B0",
  iconTertiary: "#FFC107",
  iconSuccess: "#4CAF50",
  iconWarning: "#FFC107",
  iconError: "#B00020",
  iconDisabled: "#9E9E9E",

  // 보더
  // Border Colors
  borderLight: "#E0E0E0",
  borderDark: "#9E9E9E",
  borderError: "#B00020",

  // 기타
  // Others / Miscellaneous
  divider: "#E0E0E0",
  overlay: "#000000",
  shadowLight: "#E0E0E0",
  shadowMedium: "#B0BEC5",
  shadowDark: "#78909C",

  link: "#1976D2",
  linkHover: "#1565C0",
  linkActive: "#0D47A1",
  linkDisabled: "#9E9E9E",

    hoverText: '#6B32B4',
      border: '#B5B5EA',
  
  input: '#ffffff',
  onInput1 : '#B3B3B3',
  onInput2: '#666666',
  onInput3: '#262626',
  onInput4: '#ED2424',
  onInput5: '#949494',

  btnA : '#A6D4D1',
  btnAHover: '#297873',
  btnAActive: '#69B5B0',
  onBtnA: '#FFFFFF',

  btnC : '#f3f3f3',
  onBtnC: '#949494',
  btnCEmphasis: '#f3f6f6',
  onBtnCEmphasis: '#297873',

  btnE : '#A6D4D1',
  onBtnE: '#262626',
  btnE_Disabled: '#CCCCCC',
  onBtnE_Disabled: '#949494',
  btnE_Hover: '#262626',
  onBtnE_Hover: '#FFFFFF',

  onPopup: '#f3f3f3',

} as const;
